module.exports = __webpack_public_path__ + "static/media/3S.be956fb9.svg";